import { Switch as AntSwitch } from 'antd';
import styled, { css } from 'styled-components';

export const Switch = styled(AntSwitch)<{ $locked?: boolean }>`
  ${({ $locked }) =>
    $locked &&
    css`
      &.ant-switch-disabled {
        opacity: 1;
      }
    `}
`;
